var AttributedString, Emitter, RunBuffer, _;

RunBuffer = require('./run-buffer');

Emitter = require('event-kit').Emitter;

_ = require('underscore-plus');

AttributedString = (function() {

  /*
  Section: Creating
   */
  function AttributedString(text) {
    var ref;
    if (text == null) {
      text = '';
    }
    if (text instanceof AttributedString) {
      this.string = text.getString();
      this.runBuffer = (ref = text.runBuffer) != null ? ref.clone() : void 0;
    } else {
      this.string = text;
    }
  }

  AttributedString.prototype.clone = function(location, length) {
    var clone, insertRuns, slice;
    if (location == null) {
      location = 0;
    }
    if (length == null) {
      length = -1;
    }
    if (length === -1) {
      length = this.getLength() - location;
    }
    if (length === 0) {
      return new AttributedString();
    } else {
      clone = new AttributedString(this.string.substr(location, length));
      if (this.runBuffer) {
        slice = this.runBuffer.sliceSpansToRange(location, length);
        insertRuns = [];
        this.runBuffer.iterateRuns(slice.spanIndex, slice.count, function(run) {
          return insertRuns.push(run.clone());
        });
        clone._getRunIndex().replaceSpansFromLocation(0, insertRuns);
      }
      return clone;
    }
  };


  /*
  Section: Characters
   */

  AttributedString.prototype.string = null;

  AttributedString.prototype.getString = function() {
    return this.string.toString();
  };

  AttributedString.prototype.getLength = function() {
    return this.string.length;
  };

  AttributedString.prototype.length = null;

  Object.defineProperty(AttributedString.prototype, 'length', {
    get: function() {
      return this.string.length;
    }
  });

  AttributedString.prototype.substring = function(start, end) {
    return this.string.substring(start, end);
  };

  AttributedString.prototype.substr = function(start, length) {
    return this.string.substr(start, length);
  };

  AttributedString.prototype.charAt = function(position) {
    return this.string.charAt(position);
  };

  AttributedString.prototype.charCodeAt = function(position) {
    return this.string.charCodeAt(position);
  };

  AttributedString.prototype.deleteRange = function(location, length) {
    if (!length) {
      return;
    }
    return this.replaceRange(location, length, '');
  };

  AttributedString.prototype.insertText = function(location, text) {
    if (!text.length) {
      return;
    }
    return this.replaceRange(location, 0, text);
  };

  AttributedString.prototype.appendText = function(text) {
    return this.insertText(this.string.length, text);
  };

  AttributedString.prototype.replaceRange = function(location, length, text) {
    var insertRuns, insertString, ref, textRunBuffer;
    if (length === -1) {
      length = this.getLength() - location;
    }
    if (text instanceof AttributedString) {
      insertString = text.string;
      if (this.runBuffer) {
        textRunBuffer = text._getRunIndex();
      } else {
        textRunBuffer = text.runBuffer;
      }
    } else {
      insertString = text;
    }
    insertString = insertString.split(/\u000d(?:\u000a)?|\u000a|\u2029|\u000c|\u0085/).join('\n');
    this.string = this.string.substr(0, location) + insertString + this.string.substr(location + length);
    if ((ref = this.runBuffer) != null) {
      ref.replaceRange(location, length, insertString);
    }
    if (textRunBuffer && text.length) {
      if (this.runBuffer) {
        this.setAttributesInRange({}, location, text.length);
      }
      insertRuns = [];
      textRunBuffer.iterateRuns(0, textRunBuffer.getRunCount(), function(run) {
        return insertRuns.push(run.clone());
      });
      return this._getRunIndex().replaceSpansFromLocation(location, insertRuns);
    }
  };


  /*
  Section: Attributes
   */

  AttributedString.prototype._getRunIndex = function() {
    var runBuffer;
    if (!(runBuffer = this.runBuffer)) {
      this.runBuffer = runBuffer = new RunBuffer;
      this.runBuffer.insertString(0, this.string.toString());
    }
    return runBuffer;
  };

  AttributedString.prototype.getRuns = function() {
    if (this.runBuffer) {
      return this.runBuffer.getRuns();
    } else {
      return [];
    }
  };

  AttributedString.prototype.getFirstOccuranceOfAttribute = function(attribute, effectiveRange, longestEffectiveRange) {
    var eachRun, i, len, ref;
    ref = this.getRuns();
    for (i = 0, len = ref.length; i < len; i++) {
      eachRun = ref[i];
      if (eachRun.attributes[attribute] != null) {
        return this.getAttributeAtIndex(attribute, eachRun.getLocation(), effectiveRange, longestEffectiveRange);
      }
    }
    return null;
  };

  AttributedString.prototype.getAttributesAtIndex = function(index, effectiveRange, longestEffectiveRange) {
    if (index >= this.length) {
      throw new Error("Invalide character index: " + index);
    }
    if (this.runBuffer) {
      return this.runBuffer.getAttributesAtIndex(index, effectiveRange, longestEffectiveRange);
    } else {
      if (effectiveRange) {
        effectiveRange.location = 0;
        effectiveRange.length = this.length;
      }
      if (longestEffectiveRange) {
        longestEffectiveRange.location = 0;
        longestEffectiveRange.length = this.length;
      }
      return {};
    }
  };

  AttributedString.prototype.getAttributeAtIndex = function(attribute, index, effectiveRange, longestEffectiveRange) {
    if (index >= this.length) {
      throw new Error("Invalide character index: " + index);
    }
    if (this.runBuffer) {
      return this.runBuffer.getAttributeAtIndex(attribute, index, effectiveRange, longestEffectiveRange);
    } else {
      if (effectiveRange) {
        effectiveRange.location = 0;
        effectiveRange.length = this.length;
      }
      if (longestEffectiveRange) {
        longestEffectiveRange.location = 0;
        longestEffectiveRange.length = this.length;
      }
      return void 0;
    }
  };

  AttributedString.prototype.setAttributesInRange = function(attributes, index, length) {
    return this._getRunIndex().setAttributesInRange(attributes, index, length);
  };

  AttributedString.prototype.addAttributeInRange = function(attribute, value, index, length) {
    return this._getRunIndex().addAttributeInRange(attribute, value, index, length);
  };

  AttributedString.prototype.addAttributesInRange = function(attributes, index, length) {
    return this._getRunIndex().addAttributesInRange(attributes, index, length);
  };

  AttributedString.prototype.removeAttributeInRange = function(attribute, index, length) {
    if (this.runBuffer) {
      return this.runBuffer.removeAttributeInRange(attribute, index, length);
    }
  };


  /*
  Section: Extracting a Substring
   */

  AttributedString.prototype.attributedSubstringFromRange = function(location, length) {
    if (location == null) {
      location = 0;
    }
    if (length == null) {
      length = -1;
    }
    return this.clone(location, length);
  };


  /*
  Section: Debug
   */

  AttributedString.prototype.toString = function() {
    if (this.runBuffer) {
      return this.runBuffer.toString();
    } else if (this.string) {
      return "(" + this.string + ")";
    } else {
      return '';
    }
  };

  return AttributedString;

})();

AttributedString.ObjectReplacementCharacter = '\ufffc';

AttributedString.LineSeparatorCharacter = '\u2028';

module.exports = AttributedString;

require('./attributed-string-from-bml');

require('./attributed-string-to-bml');



/*****************
 ** WEBPACK FOOTER
 ** ./lib/attributed-string.js
 ** module id = 7
 ** module chunks = 0
 **/